
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22","viewBox":"0 0 22 22"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.14 4.633a.386.386 0 00-.53 0l-8.56 8.56a.375.375 0 000 .53l3.21 3.21a.375.375 0 00.53 0l8.56-8.558a.375.375 0 000-.53l-3.21-3.212zm-9.89 9.9a.375.375 0 00-.621.15l-1.605 4.814a.375.375 0 00.474.475l4.815-1.604a.375.375 0 00.15-.622L4.25 14.533zm14.976-11.77a2.71 2.71 0 00-3.741 0l-.534.535a.375.375 0 000 .53l3.21 3.21a.375.375 0 00.53 0l.535-.538a2.648 2.648 0 000-3.737z","fill":"#FFF"}})])
          )
        }
      }
    